"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Header;
(function (Header) {
    Header["CORRELATION_HEADER"] = "x-cid";
    Header["ATTRIBUTION_HEADER"] = "Auction-Graph-Source";
    Header["XSRF_HEADER"] = "X-XSRF-TOKEN";
})(Header || (Header = {}));
exports.default = Header;
//# sourceMappingURL=headers.js.map